import React, { useRef } from "react";
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CustomTooltip from "../ui/CustomTooltip";
import "./PipelineHeader.css"; // Importa el CSS externo

export default function PipelineHeader({
  bomba,
  userLevel,
  modeAuto,
  statusMessage,
  pipelineTooltipBg,
  fallaSensor,
  translate, statusGenerator,
  cantidad_bombas,
  tieneDatosCompletos
}) {

  const containerRef = useRef(null);

  const shouldShowButton = userLevel > 1 || modeAuto;
  const statusAlarm = statusGenerator === (null || undefined) ? true : statusGenerator

  // Variables de texto centralizadas
  const TEXTS = {
    aliasDefault: "--",
    tooltipSensor: translate('tooltipSensor'),
    auto: translate("auto"),
    remoto: translate("remoto"),
  };


  return (
    <div 
      className="pipeline-header" 
      style={{ backgroundColor: statusMessage ? "#7f1d1d" : "transparent" }}
    >
      <div className={`pipeline-alias ${fallaSensor ? "wide" : ""}`}>
        <p className={`alias-text ${statusMessage ? 'error':''}`}>
          {/* {isNaN(bomba.alias) ? '--' : bomba.alias} */}
          {isNaN(bomba.alias) ? TEXTS.aliasDefault : bomba.alias}
        </p>

        {fallaSensor && tieneDatosCompletos&& (
          <CustomTooltip
            variant={pipelineTooltipBg}
            // title={"Revisar sensor: valores inusuales detectados.\nMostrando promedio de sensores cercanos"}
            title={TEXTS.tooltipSensor}
            arrow
          >
            <WarningRoundedIcon className="warning-icon"/>
          </CustomTooltip>
        )}
      </div>

      { statusMessage && 
        <div ref={containerRef} className={`pipeline-status ${shouldShowButton ? "narrow" : "wide"} ${cantidad_bombas === 1 ? "single" : ""}`} >
          <div className={`status-text ${cantidad_bombas === 1  ? "" : "marquee"}`} >
            <p>{statusMessage ?? ""}</p>
          </div>
        </div>
      }

      {shouldShowButton && (
        <div className="pipeline-button">
          <button className="control-btn"  >
            <span className="animated-btn__text">
              {/* {Boolean(bomba.Control) ? 'Auto' : 'Remoto'} */}
              {Boolean(bomba.Control) ? TEXTS.auto : TEXTS.remoto}
            </span>
          </button>
        </div>
      )}
    </div>
  );
}
